<div class="modal-header">
  <h4 class="modal-title">{{ 'modales.lockedContent.title' | translate }}</h4>
</div>
<div class="modal-body">
  <div class="contentContainer">
    <div class="text">
      {{ 'modales.lockedContent.text' | translate }}
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="goToHome()" type="button" class="btn btn-primary">
    {{ 'modales.lockedContent.backToHome' | translate }}
  </button>
</div>
